import React, { Component } from "react";
import axios from "axios";
import { Grid, Row, Col } from "react-bootstrap";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { CSVLink } from "react-csv";
import ReactTable from "react-table";

class PrintoManifestCante extends Component {
  state = {
    CantaKodi: "",
    AgjensiaBurim: window.UserP.agencyId,
    PerdoruesId: "",
    IdProcesori: "",
    Data1: new Date(),
    loading: false,
    alert: null,
    txtAgjensi: true,
    posts: [{}],
    postsexcel: [],
    Agjensi: window.UserP.agencyId,
    username: window.UserP.username,
    Destinacioni: "",
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };

  printfunction = (post) => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
      
    );
    var JsBarcode = require("jsbarcode");

    var canvas = document.createElement("canvas");
    JsBarcode(canvas, this.state.CantaKodi, {
      format: "CODE39",
      width: 1,
      height: 50,
    });
    let test = this.state.posts;
    var test5 =
      "&nbsp" +
      // "<table >" +
      "<tr>" +
      "<th >" +
      "Agjensia/Korrieri " +
      this.state.AgjensiaBurim +
      "<br>" +
      "Agjensia Destinacion:" +
      this.state.Destinacioni +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "Data" +
      this.state.Data1.toLocaleDateString() +
      "<br>" +
      "</th>" +
      "<br>" +
      "<img src='" +
      canvas.toDataURL("image/png") +
      "'>" +
      "<br>" +
      "Manifest Canta" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<tr>" +
      "<th >" +
      "Pod" +
      "</th>" +
      " <th>" +
      "Derguesi" +
      "</th>" +
      " <th>" +
      "Marresi" +
      "</th>" +
      " <th>" +
      "K.Prod" +
      "</th>" +
      "<th>" +
      "Pesha(Kg)" +
      "</th>" +
      "<th>" +
      "Men.Pagese" +
      "</th>" +
      "<th>" +
      "Shtesa" +
      "</th>" +
      "<th>" +
      "Vlera" +
      "</th>" +
      " <th>" +
      "KPagesa" +
      "</th>" +
      "  </tr>";

    for (var i = 0; i < test.length; i++) {
      
      test5 +=
        "<tr >" +
        "<td >" +
        test[i].Nr_POD 
        +"</td>" +
        " <td >" +
        test[i].Derguesi 
        +"</td>" +
        " <td >" +
        test[i].Marresi 
        +"</td>" +
        " <td >" +
        test[i].Pesha__kg_ 
        +"</td>" +
        " <td >" +
        test[i].Kod_Produkti 
        +"</td>" +
        " <td>" +
        test[i].Menyra_Dergeses 
        +"</td>" +
        " <td>" +
        test[i].Shtesa 
         +
        "</td>" +
        " <td>" +
        test[i].Vlera 
         +
        "</td>" +
        " <td>" +
        test[i].Kundrejt_Pagesa 
         +
        "</td>" +
        "   </tr>" ;
    }

    test5 += "</table></font>";

    myWindow.document.write(test5);

    myWindow.focus();
    myWindow.print();
  };

  hideAlert() {
 
    this.setState({
      alert: null,
    });
  }

  showErrors() {
    const getAlert = () => (
      <SweetAlert
        warning
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
    //  console.log("alert", this.state.alert);
  }

  showResponse() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });

  }

  remove(arr) {
    for (var i = arr.length - 1; i >= 0; i--) {
      if (isNaN(arr[i]) || arr[i] === undefined || arr[i] === null) {
        // Which is same as
        // if (!arr[i]) {
      }
    }

 
  }

  handleClick = (e) => {
    const req = {
      CantaKodi: this.state.CantaKodi,
      AgjensiaBurim: window.UserP.agencyId,
      PerdoruesId: window.UserP.PerdoruesID,
      IdProcesori: window.UserP.idProcesori,
      username: this.state.username,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
    };
    this.setState({ loading: true }, () => {
      axios
        .post(window.UserP.url + "POD/PrintoManifestCanteAgjDest", req)
        .then((response) => {
          //  if (searchresults.Result === true) {
          this.setState({
            loading: false,
            posts: response.data,
          });
          //this.showResponse();
          this.printfunction(this.state.posts);
       
          //   } else {
          //     this.setState({
          //       loading: false,
          //       error1: searchresults.ResultMessage,
          //     });

          //     console.log("reatcttable", this.state.error1, this.state.alert);
          //     this.showErrors();
        });
      //     .catch((error) => {
      //       this.setState({
      //         loading: false,
      //         error1: "Ju lutem kontaktoni departamentin e IT!",
      //       });
      //       this.showErrors();
      //     });
    });
  };
  handleClickExcel = (e) => {
    const req = {
      CantaKodi: this.state.CantaKodi,
      AgjensiaBurim: window.UserP.agencyId,
      PerdoruesId: window.UserP.PerdoruesID,
      IdProcesori: window.UserP.idProcesori,
      username: this.state.username,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
    };
    console.log(req);
    this.setState({ loading: true }, () => {
      axios
        .post(window.UserP.url + "POD/PrintoManifestCanteAgjDest", req)
        .then((response) => {
          //  if (searchresults.Result === true) {
           for (var i =0; i < response.data.length; i++)
           {
            const dataexcel = {
              Nr_POD: response.data[i].Nr_POD,
              Derguesi: response.data[i].Derguesi,
              Marresi: response.data[i].Marresi,
              Kod_Produkti: response.data[i].Kod_Produkti,
              Menyra_Dergeses: response.data[i].Menyra_Dergeses,
              Shtesa: response.data[i].Shtesa,
              Vlera: response.data[i].Vlera,
              Kundrejt_Pagesa: response.data[i].Kundrejt_Pagesa,
              Destinacioni: response.data[i].Destinacioni,
              Pesha__kg_: response.data[i].Pesha__kg_,
              Pershkrimi: response.data[i].Pershkrimi,
              Debitimi: response.data[i].Debitimi,
             // Verejtje: response.data[i].Verejtje,
            }

            this.state.postsexcel.push(dataexcel);
           }

           this.setState({
            loading: false,
            postsexcel: this.state.postsexcel,
            kerko: true,
          });

          //this.showResponse();
          //this.printfunction(this.state.posts);
       
          //   } else {
          //     this.setState({
          //       loading: false,
          //       error1: searchresults.ResultMessage,
          //     });

          //     console.log("reatcttable", this.state.error1, this.state.alert);
          //     this.showErrors();
        });
      //     .catch((error) => {
      //       this.setState({
      //         loading: false,
      //         error1: "Ju lutem kontaktoni departamentin e IT!",
      //       });
      //       this.showErrors();
      //     });
    });
  };
  handleClickPastro = (e) => {
   this.setState({
    posts: [{}],
    postsexcel: [],
    CantaKodi: "",
    kerko: false
  })
  };

  render() {
    const columns = [
      {
        Header: "Nr",

        id: "row",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "Nr.POD",
        accessor: "Nr_POD",
        maxWidth: 400,
        minWidth: 140,
        width: 200,
      },

      {
        Header: "Derguesi",
        accessor: "Derguesi",
      },
      {
        Header: "Marresi",
        accessor: "Marresi",
      },
      {
        Header: "Kod_Produkti",
        accessor: "Kod_Produkti",
      },
      {
        Header: "Menyra_Dergeses",
        accessor: "Menyra_Dergeses",
      },
      {
        Header: "Shtesa",
        accessor: "Shtesa",
      },

      {
        Header: "Vlera",
        accessor: "Vlera",
      },
      {
        Header: "Kundrejt_Pagesa",
        accessor: "Kundrejt_Pagesa",
      },
      {
        Header: "Destinacioni",
        accessor: "Destinacioni",
      },
      {
        Header: "Pesha__kg_",
        accessor: "Pesha__kg_",
      },
      {
        Header: "Pershkrimi",
        accessor: "Pershkrimi",
      },
      {
        Header: "Debitimi",
        accessor: "Debitimi",
      },
      // {
      //   Header: "Verejtje",
      //   accessor: "Verejtje",
      // },
    ];


    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div className="Form">
                <div className="card card-body bg-light col-md-5 mt-4">
                  <label className="">Pod Transporti</label>
                  <input
                    id="CantaKodi"
                    name="CantaKodi"
                    value={this.state.CantaKodi}
                    className="form-control "
                    type="text"
                    onChange={(e) => this.handleInputChange(e, "CantaKodi")}
                  />
                </div>
                <div className="card card-body bg-light col-md-5 mt-4">
                  <label className="">Agjensia</label>
                  <input
                    className="form-control "
                    value={this.state.AgjensiaBurim}
                    type="text"
                    //   onChange={e => this.handleInputChange(e, "Agjensi")}
                    disabled={this.state.txtAgjensi}
                  />
                </div>

                {this.state.kerko?
                (<div>
                  <button
                  className="btn btn-primary "
                  onClick={() => this.handleClick()}
                >
                  Printo
                </button>
                <button
                  className="btn btn-primary "
                  onClick={() => this.handleClickExcel()}
                >
                  Kerko
                </button>
               
                  <CSVLink data={this.state.postsexcel}>
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
            
            
                <button 
                className="btn btn-primary ml-4 "
                onClick={() => this.handleClickPastro()}
                >Pastro</button>
                </div>

                )
                :
                (
                <div>
                  <button
                  className="btn btn-primary "
                  onClick={() => this.handleClick()}
                >
                  Printo
                </button>
                <button
                  className="btn btn-primary "
                  onClick={() => this.handleClickExcel()}
                >
                  Kerko
                </button>
               
                <button 
                className="btn btn-primary ml-4 "
                onClick={() => this.handleClickPastro()}
                >Pastro</button>
                </div>
                )
              }
                
              </div>
            )}
            <div className="row mt-2">
              <div className="col-md-12 ">
                <ReactTable
                  columns={columns}
                  data={this.state.postsexcel}
                  defaultPageSize={10}
                  className="-striped -highlight mt-4"
                  pageText="Faqe"
                  nextText="Para"
                  rowsText="Rreshta"
                  previousText="Mbrapa"
                  noDataText="Nuk ka te dhena"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default PrintoManifestCante;
